<template>
      <main>
        <loading-container :loading="loading" @loaded="init">
          <organization_header :rate="rate"/>
          <div class="body">
            <div class="top">
              <div class="top__title column">
                <div class="name">
                  Об организации
                </div>
                <div class="top__title-radio">
                  <!--<div
                      class="top__title-radio-item"
                      v-for="(item) in tabs"
                      :class="{active: selected == item.key}"
                      :key="item.key"
                      @click="selected = item.key"
                  >
                    {{item.title}}
                  </div>-->
                </div>
              </div>
              <div class="top__title col fz-14">
                Статус пользователя в системе:
                <div class="status">
                  {{status == 1 ? 'Поставщик' : 'Закупщик'}}
                </div>
              </div>
              <div class="top__title col fz-14 ds">
                Участие в системе дропшиппинга:
                <div :class="{status: $store.getters.getCompany.dropshipping, off: !$store.getters.getCompany.dropshipping}">
                  {{$store.getters.getCompany.dropshipping == 1 ? 'Включено' : 'Выключено'}}
                </div>
              </div>

            </div>
            <div class="content">
              <div class="column">
                <h4>Публичное название компании*</h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" name="company_name" v-model="name" v-validate="'required'" data-vv-validate-on="blur" value="">
                  <span class="text-danger text-sm">{{ errors.first('company_name') }}</span>
                </div>
                <!--<h4>Логин</h4>
                <input type="text" value="Ribalka-ohota">
                <h4>Пароль</h4>
                <div class="password">
                  <input type="password" value="password">
                  <button></button>
                </div>-->
                <div class="logo">
                  <img :src="getAvatar(url)" alt="">
                  <app-button @click="fileInput" outlined class="ml-2">Изменить логотип</app-button>
                  <img src="@/assets/icons/trash.svg" alt="" v-if="url != 'https://api.superbaer24.ru/storage/'" class="trash hover_btn" @click.stop="deletePhoto()">
                  <input type="file" ref="file" hidden name="photo" accept=".jpg, .jpeg, .png, .bmp"  @change="onFileChange">
                </div>
                <h4>Телефон*</h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" v-validate="'required'" data-vv-validate-on="blur" name="phone" v-model="phone" id="phone-field" value="">
                  <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
                </div>
                <h4>E-mail*</h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" v-validate="'required|email'" v-model="email" name="email" data-vv-validate-on="blur" value="">
                  <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                </div>
                <h4>Сайт компании</h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" v-model="site" value="ohota.ru">
                </div>
                <h4>Сайт интернет-магазина</h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" v-model="address">
                </div>
                <h4>О компании</h4>
                <app-ckeditor v-model="about"/>
               <!-- <textarea v-model="about" name="" id="" cols="30" rows="10" style="resize:none" ></textarea>-->
                <!--<input class="about" v-model="about" type="text">-->
                <h4 class="date-header">Дата основания</h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" v-model="foundation_date">
                </div>

              </div>
              <div class="col">
                <table>
                  <tr>
                    <th width="48px" @click="orderBay">ID<img :style="rotate ? rotate : ''" src="@/assets/img/main/open.svg"></th>
                    <th>Наименование</th>
                    <th>ИНН</th>
                    <th>Статус</th>
                    <th></th>
                  </tr>
                  <tr v-for="(entity, key) in entities" :key="entity.id">
                    <td>{{key+1}}</td>
                    <td>
                      <!--<img src="" alt="" class="worker-avatar">-->
                      <span><a href="#" @click.prevent="view(entity.id)">{{entity.company_name}}</a></span>
                    </td>
                    <td>{{entity.inn}}</td>
                    <td :class="{'true': entity.active}">{{entity.active ? 'Работает' : 'Не работает'}}</td>
                    <td class="action" @click="edit(entity.id)">
                        <img class="hover_btn" src="@/assets/img/main/edit.svg" alt="" width="15px">
                    </td>
                  </tr>
                  <!--<tr>
                    <td>2</td>
                    <td>
                      <img src="" alt="" class="worker-avatar">
                      <span>ООО "Лески"</span>
                    </td>
                    <td>344407702933</td>
                    <td>Не работает</td>
                  </tr>-->
                </table>
                <div class="add">
                  <app-button class="mt-2" @click="addOrg()">Добавить организацию</app-button>
                </div>

                <adress-modal ref="adr" :name="'address'" @save="adressSave" title="Адрес доставки"/>
                <div v-if="status == 2" class="title font-weight-bold">Адреса доставки</div>
                <table v-if="status == 2">
                  <tr>
                    <th>Адрес</th>
                    <th></th>
                    <th style="text-align: center;">Активный</th>
                  </tr>
                  <tr v-for="(address) in addresses" :key="'address' + address.id">
                    <th>{{address.human_address}}</th>
                    <td class="action" @click="$refs.adr.open(getAddress('legal', address))">
                      <img class="hover_btn" src="@/assets/img/main/edit.svg" alt="" width="15px">
                    </td>
                    <td style="text-align: center;">
                        <div style="display: inline-block;">
                            <app-checkbox v-model="address.active" @change="toggleActive(address.id, address.active)" white table/>
                        </div>
                    </td>
                  </tr>
                </table>
                <div v-if="status == 2" class="add">
                  <app-button class="mt-2" @click="$refs.adr.open(getAddress('legal', {}))">Добавить адрес</app-button>
                </div>

                <provider-terminal-modal ref="terminal" @saved="getCompany()"/>
                <div v-if="status == 1" class="title font-weight-bold">Терминалы отправки</div>
                <table v-if="status == 1">
                  <tr>
                    <th>ТК</th>
                    <th>Терминал</th>
                    <th>Адрес</th>
                    <th></th>
                  </tr>
                  <tr v-for="terminal in terminals" :key="'terminal-' + terminal.id">
                    <th>{{terminal.address.name}}</th>
                    <th>{{terminal.address.terminal}}</th>
                    <th>{{terminal.address.name == 'ПЭК' ? terminal.warehouse_address : terminal.address.address}}</th>
                    <td class="action" @click="$refs.terminal.open(terminal)">
                      <img class="hover_btn" src="@/assets/img/main/edit.svg" alt="" width="15px">
                    </td>
                  </tr>
                </table>
                <div class="add" v-if="status == 1">
                  <app-button class="mt-2" @click="$refs.terminal.open('', terminals)">Добавить терминал</app-button>
                </div>

                <purchaser-logist-modal ref="logist" @saved="getCompany()"/>
                <div v-if="status == 2" class="title font-weight-bold">Логист</div>
                <table v-if="status == 2">
                  <tr>
                    <th>ФИО</th>
                    <th>Телефон</th>
                    <th></th>
                  </tr>
                  <tr v-if="logist">
                    <th>{{logist.surname}}</th>
                    <th>{{logist.name}}</th>
                    <th>{{logist.phone}}</th>
                    <td class="action" @click="$refs.logist.open(logist)">
                      <img class="hover_btn" src="@/assets/img/main/edit.svg" alt="" width="15px">
                    </td>
                  </tr>
                </table>
                <div class="add">
                  <div style="margin-bottom: 60px;" v-if="status == 2 && logist"></div>
                  <app-button v-if="status == 2 && !logist" class="mt-2" @click="$refs.logist.open()">Добавить</app-button>
                </div>

                <adress-modal ref="officeAdr" :name="'office_address'" @save="officeAdressSave" title="Адрес доставки"/>
                <div class="title font-weight-bold">Адрес офиса</div>
                <table>
                  <tr>
                    <th>Адрес</th>
                    <th></th>
                  </tr>
                  <tr v-for="(address) in office_addresses" :key="'office_address' + address.id">
                    <th>{{address.human_address}}</th>
                    <td class="action" @click="$refs.officeAdr.open(getAddress('legal', address))">
                      <img class="hover_btn" src="@/assets/img/main/edit.svg" alt="" width="15px">
                    </td>
                  </tr>
                </table>
                <div class="add">
                  <app-button class="mt-2" @click="$refs.officeAdr.open(getAddress('legal', {}))">Добавить адрес</app-button>
                </div>

                <div class="sec">
                  <h4 class="dis">Youtube</h4>
                  <div class="input-block">
                    <input autocomplete="off" type="text" v-model="youtube">
                  </div>
                  <h4 class="dis">OK</h4>
                  <div class="input-block">
                    <input autocomplete="off" type="text" v-model="ok">
                  </div>
                  <h4 class="dis">ЯRUS</h4>
                  <div class="input-block">
                    <input autocomplete="off" type="text" v-model="yarus">
                  </div>
                  <h4 class="dis">NOW</h4>
                  <div class="input-block">
                    <input autocomplete="off" type="text" v-model="now">
                  </div>
<!--                  <h4 class="dis">Instagram</h4>-->
<!--                  <div class="input-block">-->
<!--                    <input autocomplete="off" type="text" v-model="instagram">-->
<!--                  </div>-->
<!--                  <h4 class="dis">Facebook</h4>-->
<!--                  <div class="input-block">-->
<!--                    <input autocomplete="off" type="text" v-model="facebook">-->
<!--                  </div>-->
                  <h4 class="dis">Вконтакте</h4>
                  <div class="input-block">
                    <input autocomplete="off" type="text" v-model="vk">
                  </div>
                  <app-button class="mt-3" big @click="send()">Сохранить</app-button>
                </div>

              </div>
            </div>
          </div>
        </loading-container>
      </main>
</template>

<script>
    import organization_header from "@/components/OrganizationHeader.vue"
    import Inputmask from 'inputmask'
    import LoadingContainer from "@/components/loading-container";
    import AdressModal from "@/components/modals/adress-modal";
    import AppButton from "@/components/app-button";
    import AppCheckbox from "@/components/app-checkbox";
    import AppCkeditor from "@/components/app-ckeditor";
    import ProviderTerminalModal from "@/components/modals/provider-terminal-modal";
    import PurchaserLogistModal from "@/components/modals/purchaser-logist-modal";
    /*import store from "@/store";*/


    export default {
        name: "profile",
        data: ()=>({
          rate: {
            rating: 0,
            amount: 0,
            isIndicatorActive: true,
            isIndicatorAmountActive: true,
          },
            options: ['Менеджер', 'Стажер', 'Продавец'],
            tabs: [
                {
                    title: 'Юр. лицо',
                    key: '0',
                },
                {
                    title: 'ИП',
                    key: '1',
                },

            ],
            selected: '0',
            token: '',
            name: '',
            phone: '',
            email: '',
            site: '',
            address: '',
            about: '',
            youtube: '',
            instagram: '',
            facebook: '',
            yarus: '',
            ok: '',
            now: '',
            vk: '',
            entities: [],
            file: '',
            url: '',
            loading: true,
            status: '',
            addresses: [],
            address_edit: '',
            order_company_asc: true,
            rotate: '',
            foundation_date: '',
            office_addresses: [],
            company: [],
            terminals: [],
            logist: []
        }),
        mounted () {
          this.status = localStorage.getItem('type');
          this.getCompany()
        },
        beforeRouteLeave (to, from, next) {
          // If the form is dirty and the user did not confirm leave,
          // prevent losing unsaved changes by canceling navigation
          if (this.confirmStayInDirtyForm()){
            next(false)
          } else {
            // Navigate to next view
            next()
          }
        },
        created() {
          window.addEventListener('beforeunload', this.beforeWindowUnload)
        },
        beforeDestroy() {
          window.removeEventListener('beforeunload', this.beforeWindowUnload)
        },
        components: {
          AppButton,
          LoadingContainer,
          organization_header,
          AdressModal,
          AppCheckbox,
          AppCkeditor,
          ProviderTerminalModal,
          PurchaserLogistModal
        },
        methods: {
          confirmLeave() {
            return window.confirm('Вы действительно хотите уйти? Несохраненные данные будут утеряны!')
          },

          confirmStayInDirtyForm() {
            return this.dirty() && !this.confirmLeave()
          },
          dirty() {
            if (this.name != this.company.name) {
                return true;
            }
            if (this.phone != this.company.phone) {
              return true;
            }
            if (this.email != this.company.email) {
              return true;
            }
            if (this.site != this.company.site) {
              return true;
            }
            if (this.address != this.company.address) {
              return true;
            }
            if (this.about != this.company.about) {
              return true;
            }
            if (this.youtube != this.company.youtube) {
              return true;
            }
            if (this.instagram != this.company.instagram) {
              return true;
            }
            if (this.facebook != this.company.facebook) {
              return true;
            }
            if (this.vk != this.company.vk) {
              return true;
            }
            if (this.now != this.company.now) {
              return true;
            }
            if (this.ok != this.company.ok) {
              return true;
            }
            if (this.yarus != this.company.yarus) {
              return true;
            }
            if (this.foundation_date != this.company.foundation_date) {
              return true;
            }

            return false;
          },
          afterSave() {
            this.company.name = this.name;
            this.company.phone = this.phone;
            this.company.email = this.email
            this.company.site = this.site;
            this.company.address = this.address;
            this.company.about = this.about;
            this.company.youtube = this.youtube;
            this.company.instagram = this.instagram;
            this.company.facebook = this.facebook;
            this.company.ok = this.ok;
            this.company.yarus = this.yarus;
            this.company.now = this.now;
            this.company.vk = this.vk;
            this.company.foundation_date = this.foundation_date;
          },
          beforeWindowUnload(e) {
            if (this.confirmStayInDirtyForm()) {
              // Cancel the event
              e.preventDefault()
              // Chrome requires returnValue to be set
              e.returnValue = ''
            }
          },
          orderBay(){
            this.order_company_asc = this.order_company_asc ? false : true;
            if (!this.order_company_asc) {
              this.rotate = 'transform: rotate(180deg)';
            }else {
              this.rotate = '';
            }
            this.getCompany()
          },
          init(){
            var im = new Inputmask("+7 (999) 999 99 99");
            im.mask(document.getElementById('phone-field'));
          },
          getAvatar(avatar){
            if(avatar == 'https://api.superbaer24.ru/storage/') return require('@/assets/icons/user.svg')
            else return avatar
          },
          toggleActive(id, active) {
            this.$http.post('/toggle-active-address', {
              token: localStorage.getItem('token'),
              active: active ? 1 : 0,
              id: id
            })
            .then(({data}) => {
              if (data.success) {
                this.$toast.success(active ? 'Адрес успешно активирован!' : 'Адрес успешно деактивирован!');
              }
            })
            .catch((error) => {
              console.log(error)
            })
          },
          getCompany () {
            if (localStorage.getItem('token')) {
              this.loading = true;
              this.$http.post('/get-company', {
                token: localStorage.getItem('token'),
                asc:this.order_company_asc
              })
                  .then(({data}) => {
                  if (data.company) {
                    this.name = data.company.name
                    this.phone = data.company.phone
                    this.email = data.company.email
                    this.site = data.company.site
                    this.address = data.company.address
                    this.about = data.company.about
                    this.youtube = data.company.youtube
                    this.instagram = data.company.instagram
                    this.facebook = data.company.facebook
                    this.yarus = data.company.yarus
                    this.ok = data.company.ok
                    this.now = data.company.now
                    this.vk = data.company.vk
                    this.entities = data.company.entities
                    this.url = data.company.logo,
                    this.addresses = data.company.addresses
                    this.rate.rating = data.company.review_avg
                    this.rate.amount = data.company.reviews_count
                    this.foundation_date = data.company.foundation_date
                    this.office_addresses = data.company.office_addresses
                    this.company = data.company;
                    this.terminals = data.company.terminals;
                    this.logist = data.company.purchaser_logist
                  }
              })
              .catch((error) => {
                  console.log(error)
              })
              .finally(()=>this.loading = false)
            }
          },
          send () {
            console.log( 'test')
            this.$validator.validateAll().then(success => {
              if (success) {
                this.loading = true;
                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('token', localStorage.getItem('token'));
                formData.append('name', this.name ? this.name : '');
                formData.append('phone', this.phone ? this.phone : '');
                formData.append('email', this.email ? this.email : '');
                formData.append('site', this.site ? this.site : '');
                formData.append('address', this.address ? this.address : '');
                formData.append('about', this.about ? this.about : '');
                formData.append('youtube', this.youtube ? this.youtube : '');
                formData.append('instagram', this.instagram ? this.instagram : '');
                formData.append('facebook', this.facebook ? this.facebook : '');
                formData.append('vk', this.vk ? this.vk : '');
                formData.append('yarus', this.yarus ? this.yarus : '');
                formData.append('ok', this.ok ? this.ok : '');
                formData.append('now', this.now ? this.now : '');
                formData.append('foundation_date', this.foundation_date ? this.foundation_date : '');
                this.$http.post( '/change-company',
                        formData,
                        {
                          headers: {
                            'Content-Type': 'multipart/form-data'
                          }
                        }
                ).then((response) => {
                  if (response.data.success) {
                    this.$toast.success('Данные успешно изменены!');
                    this.afterSave();
                    /*store._vm.getCompany.logo = this.getAvatar(this.url)*/
                  }
                }).catch(function(){
                  this.$toast.error('Ошибка!');
                })
                .finally(()=>this.loading = false)
              }
            })
            /*console.log(store)*/
          },
          addOrg () {
            this.$router.push({name: 'companyAdd'})
            // let route = this.$router.resolve({name: 'companyAdd'})
            // window.open(route.href, '_blank')
          },
          onFileChange(e) {
            let t = e.target.files[0].type.split('/').pop().toLowerCase();
            if (t != "jpeg" && t != "jpg" && t != "png" && t != "bmp" && t != "gif") {
              this.$refs.file.value = ''
              return this.$toast.error('Загружаемый файл должен быть изображением!')
            }
            if (e.target.files[0].size > 5000000) {
              this.$refs.file.value = ''
              return this.$toast.error('Загружаемый файл должен иметь размер не более 5 мб.!')
            }
            this.file = e.target.files[0];
            this.url = URL.createObjectURL(this.file);
          },
          fileInput() {
            this.$refs.file.click();
          },
          edit(id) {
            this.$router.push({name: 'companyEdit', params: {id}});
          },
          view(val) {
            this.$router.push('/entity/' + val + '/view');
          },
          getAddress(type = 'legal', address){
            if (address.id) {
              this.address_edit = address.id;
            } else {
              this.address_edit = '';
            }
            let adress_arr = {};
            adress_arr[type +'_address_country'] = address.country;
            adress_arr[type +'_address_city'] = address.city;
            adress_arr[type +'_address_region'] = address.region;
            adress_arr[type +'_address_street'] = address.street;
            adress_arr[type +'_address_house'] = address.house;
            adress_arr[type +'_address_corps'] = address.corps;
            adress_arr[type +'_address_flat'] = address.flat;
            adress_arr[type +'_index'] = address.address_index;
            adress_arr[type +'_info'] = address.info;
            return adress_arr;
          },
          adressSave(payload){
            if (localStorage.getItem('token')) {
              console.log(payload);
              this.$http.post(this.address_edit ? '/change-company-address' : '/add-company-address', {
                token: localStorage.getItem('token'),
                id: this.address_edit,
                country: payload.legal_address_country,
                region: payload.legal_address_region,
                city: payload.legal_address_city,
                street: payload.legal_address_street,
                house: payload.legal_address_house,
                flat: payload.legal_address_flat,
                address_index: payload.legal_index,
                corps: payload.legal_address_corps,
                info: payload.legal_info
              }).then(({data}) => {
                if (data.success) {
                  this.$toast.success(this.address_edit ? 'Адрес успешно изменен!' : 'Адрес успешно добавлен!');
                  this.getCompany()
                }
              })
              .catch((error) => {
                  console.log(error)
              })
            }
          },
          officeAdressSave(payload){
            if (localStorage.getItem('token')) {
              this.$http.post(this.address_edit ? '/change-office-company-address' : '/add-office-company-address', {
                token: localStorage.getItem('token'),
                id: this.address_edit,
                country: payload.legal_address_country,
                region: payload.legal_address_region,
                city: payload.legal_address_city,
                street: payload.legal_address_street,
                house: payload.legal_address_house,
                flat: payload.legal_address_flat,
                address_index: payload.legal_index,
                corps: payload.legal_address_corps,
                info: payload.legal_info
              }).then(({data}) => {
                if (data.success) {
                  this.$toast.success(this.address_edit ? 'Адрес успешно изменен!' : 'Адрес успешно добавлен!');
                  this.getCompany()
                }
              })
              .catch((error) => {
                  console.log(error)
              })
            }
          },
          deletePhoto(){
            this.$http.post('/delete-company-photo', {
              token: localStorage.getItem('token'),
            }).then(({data}) => {
              if (data.success) {
                this.url = 'https://api.superbaer24.ru/storage/';
                /*store._vm.getCompany.logo = this.getAvatar(require('@/assets/icons/user-nav.svg'))*/
                this.$toast.success('Фотография удалена!');
              }
            }).catch((error) => {
              console.log(error)
            })
          }
        }
    }
</script>

<style scoped lang="scss">
  .date-header {
    margin-top: 10px;
  }
  .off {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: 21px;
    margin-left: 5px;
  }
  .ds {
    margin-left: -90px;
  }
  .add{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    button{
      width: 30%;
    }
  }
  .action {
    padding: 0;
    width: 35px !important;
    cursor: pointer;

    img {
      display: block;
      margin-right: auto !important;
      margin-left: auto !important;
    }
  }
  table {
    margin-top: 21px;
    border-collapse: collapse;
    width: 100%;
    background: #fff;
    border: 1px #a3a3a3 solid;
    border-radius: 5px;
    tr {
      &:nth-child(even) {
        background: #F9F9FB;
      }
    }
    th, td {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      padding: 7px 14px;
      height: 40px;
      text-align: left;
      a{
        text-decoration: none;
        color: #7A818F;
      }
      img{
        margin-right: -11px;
        margin-left: 2px;
      }
      &.true{
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #2CB181;        }
      &:not(:last-child) {
        border-right: 1px #a3a3a3 solid;
      }
    }
    th {
      color: #2D3137;
    }
    tr {
      color: #7A818F;
    }
  }
  main {
    padding: 30px;
    width: 85%;
  }
  h4{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
    margin: 0 0 5px 1px;
  }
  .double{
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    .calendar{
      width: 49%;
    }
  }
  .body{
   .top{
     display: flex;
     flex-wrap: wrap;
     align-items: center;
     justify-content: space-between;
     width: 100%;
     margin-bottom: 10px;
     &__title{
       display: flex;
       flex-wrap: wrap;
       .name{
         display: flex;
         align-items: center;
         font-family: Roboto;
         font-style: normal;
         font-weight: 500;
         font-size: 16px;
         line-height: 19px;
         color: #2D3137;
         margin-right: 30px;
       }
       .status{
         font-family: Roboto;
         font-style: normal;
         font-weight: normal;
         /*font-size: 12px;*/
         line-height: 21px;
         color: #2CB181;
         margin-left: 5px;
       }
       &-radio{
         font-family: Roboto;
         font-style: normal;
         font-weight: normal;
         font-size: 14px;
         line-height: 16px;
         display: flex;
         width: max-content;
         background-color: white;
         border-radius: 4px;
         border: 1px solid #EEF0F3;

         &-item {
           cursor: pointer;
           padding: 10px 15px;
           margin: 2px;
           color: #7A818F;
         }
         &-item.active {
           color: #2D3137;
           background: #EEF0F3;
           border-radius: 4px;
         }
       }
     }
   }
    .content{
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;
      input, textarea{
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          color: #7A818F;
          padding: 10px;
          width: 100%;
          height: 40px;
          background: #FFFFFF;
          border: 1px solid #EEF0F3;
          box-sizing: border-box;
          border-radius: 4px;
        &.about{
          height: 117px;
        }
          &:disabled{
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 14px;
            color: #7A818F;
            background: #EEF0F3;
          }
      }
      textarea {
          height: 116px;
      }
      .sec{
        margin-top: 62px;
        width: 50%;
      }
      .dis{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #7A818F;
      }
      .password{
        position: relative;
        button{
          margin-top: 10px;
          width: 20px;
          height: 20px;
          position: absolute;
          right: 15px;
          top: 20%;
          transform: translateY(-50%);
          background-color: transparent;
          border: none;
          background-image: url('../../assets/img/main/eye.svg');
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
          cursor: pointer;

        }
      }
      .calendar{
        position: relative;
        button{
          margin-top: 10px;
          width: 20px;
          height: 20px;
          position: absolute;
          right: 15px;
          top: 20%;
          transform: translateY(-50%);
          background-color: transparent;
          border: none;
          background-image: url('../../assets/img/main/calendar.svg');
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
          cursor: pointer;

        }
      }
      .logo{
        height: 61px;
        background: #FFFFFF;
        box-shadow: 0px 0px 3px #E5E5EA;
        border-radius: 4px;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        img{
          width: 40px;
          padding: 0;
          border: 1px solid #B6BCC8;
          //height: 40px;
        }
      }
      .checkbox {
        display: flex;
        align-items: center;
        position: relative;
        padding-left: 35px;
        margin: 10px 0 12px 0;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #7A818F;
      }
      .checkbox input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }
      .checkmark {
        position: absolute;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #eee;
        box-shadow: 0px 0px 3px #E5E5EA;
        border-radius: 4px;
      }
      .checkbox:hover input ~ .checkmark {
        background-color: #ccc;
      }
      .checkbox input:checked ~ .checkmark {
        background-color: #ccc;
      }
      .checkmark:after {
        content: "";
        position: absolute;
        display: none;
      }
      .checkbox input:checked ~ .checkmark:after {
        display: block;
      }
      .checkbox .checkmark:after {
        left: 8px;
        top: 4px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }

    }

  }

  .input-block {
    margin-bottom: 15px;
  }

  .fz-14 {
      font-size: 14px;
  }

  .column{
    width: 33%;
  }
  .col{
    width: 67%;
    padding-right: 0;
  }

  .trash{
    border: none!important;
    margin-left: 5px;
    height: 26px;
    cursor: pointer;
  }

</style>
